import { Injectable } from '@angular/core';
import { ApiConfigService } from './api-config.service';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Order, OrderListResponse, OrderStats, UpdateOrderStatusPayload } from '../../models/order.model';

@Injectable({
  providedIn: 'root'
})
export class OrderService {
  private get apiUrl(): string { return `${this.apiConfig.apiUrl}/orders`; }


  constructor(private http: HttpClient, private apiConfig: ApiConfigService) {}

  getOrders(
    status = 'all',
    paymentStatus = 'all',
    search = '',
    page = 1,
    dateFrom?: string,
    dateTo?: string
  ): Observable<OrderListResponse> {
    let params = new HttpParams().set('page', page).set('limit', 30);
    if (status && status !== 'all') params = params.set('status', status);
    if (paymentStatus && paymentStatus !== 'all') params = params.set('paymentStatus', paymentStatus);
    if (search) params = params.set('search', search);
    if (dateFrom) params = params.set('dateFrom', dateFrom);
    if (dateTo) params = params.set('dateTo', dateTo);

    return this.http.get<OrderListResponse>(this.apiUrl, { params });
  }

  getOrderStats(): Observable<OrderStats> {
    return this.http.get<OrderStats>(`${this.apiUrl}/stats`);
  }

  getOrderById(id: string): Observable<Order> {
    return this.http.get<Order>(`${this.apiUrl}/${id}`);
  }

  updateOrderStatus(id: string, payload: UpdateOrderStatusPayload): Observable<Order> {
    return this.http.put<Order>(`${this.apiUrl}/${id}/status`, payload);
  }

  // ─── SHIPROCKET INTEGRATION METHODS ──────────────────────────────────────────

  getShiprocketPickupLocations(): Observable<{ locations: any[] }> {
    return this.http.get<{ locations: any[] }>(`${this.apiUrl}/shiprocket/pickup-locations`);
  }

  createShiprocketOrder(
    id: string,
    payload: { pickupLocation?: string; weight?: number; length?: number; breadth?: number; height?: number }
  ): Observable<{ message: string; order: Order; shiprocket: any }> {
    return this.http.post<{ message: string; order: Order; shiprocket: any }>(
      `${this.apiUrl}/${id}/shiprocket/create`,
      payload
    );
  }

  generateShiprocketAWB(id: string, courierId?: number): Observable<{ message: string; order: Order; awbDetails: any }> {
    return this.http.post<{ message: string; order: Order; awbDetails: any }>(
      `${this.apiUrl}/${id}/shiprocket/generate-awb`,
      { courierId }
    );
  }

  generateShiprocketLabel(id: string): Observable<{ message: string; labelUrl: string }> {
    return this.http.post<{ message: string; labelUrl: string }>(
      `${this.apiUrl}/${id}/shiprocket/generate-label`,
      {}
    );
  }

  generateShiprocketInvoice(id: string): Observable<{ message: string; invoiceUrl: string }> {
    return this.http.post<{ message: string; invoiceUrl: string }>(
      `${this.apiUrl}/${id}/shiprocket/generate-invoice`,
      {}
    );
  }

  trackShiprocketShipment(id: string): Observable<{ tracking: any; order: Order }> {
    return this.http.get<{ tracking: any; order: Order }>(
      `${this.apiUrl}/${id}/shiprocket/track`
    );
  }
}


